<template>
	<div class="md:max-w-xl">
		<!-- <div class="">
			<button @click="scrollToDetails" class="text-xs sm:text-sm font-semibold underline text-ihh-dark-salmon hover:text-ihh-salmon">See details</button>
		</div> -->

		<div v-show="!productAndVariantsOutOfStock">
			<div class="space-y-3 my-4" v-for="po in product.productOptions" :key="po.id">
				<div class="text-sm text-ihh-slate-gray font-semibold">
					<span class="text-ihh-midnight-gray mr-2">{{ po.displayName }}:</span>
					(Required)
				</div>

				<div class="flex w-full flex-wrap gap-3 print:hidden">
					<ProductOptionButtons
						v-for="o in po.optionValues"
						:key="o.id"
						:option="o"
						:variants="product.variants"
						:selectedOptions="selectedOptions"
						:inventoryTracking="product.inventoryTracking == 'variant'"
						@click="selectOption(o)"
					/>
				</div>
			</div>
		</div>

		<div v-show="(product.outOfStock || variantsOutOfStock) && !store.editingKit?.id" @click="showNotify = true" class="w-full my-8">
			<button @click="$emit('showNotify')" class="w-full flex justify-center text-ihh-white bg-ihh-dark-salmon py-3 print:hidden active:scale-90">
				Notify me when available
			</button>
		</div>

		<div v-show="!productAndVariantsOutOfStock" class="my-8">
			<ProductModifiers
				v-for="modifier in nonTextModifiers"
				:key="modifier.id"
				:modifier="modifier"
				class="my-8"
				@optionSelected="selectModifierOption"
				@optionRemoved="removeModifierOption"
			/>
		</div>

		<!-- Text Modifier Inputs -->
		<template v-if="textValues?.length && !productAndVariantsOutOfStock && !store.editingKit?.id">
			<div v-for="(modifier, idx) in textValues" :key="modifier.id" class="mb-8">
				<label class="block mb-2 font-semibold text-base text-ihh-midnight-gray">
					{{ modifier.name }}:
					<span class="font-normal text-ihh-slate-gray text-sm ml-2">{{ modifier.required ? 'Required' : 'Optional' }}</span>
				</label>
				<input
					v-model="textValues[idx].value"
					type="text"
					class="block w-full border border-gray-400 rounded-lg px-4 py-3 text-sm text-ihh-midnight-gray focus:outline-none focus:ring-0 focus:ring-ihh-dark-salmon"
					:placeholder="modifier.placeholder || ''"
				/>
			</div>
		</template>

		<div v-show="!productAndVariantsOutOfStock || store.editingKit?.id" class="flex w-full justify-start gap-x-3 md:gap-x-2 mt-6 print:hidden px-2 md:px-3 lg:px-0">
			<div class="flex w-full justify-start items-center">
				<div :disabled="isAddToBagDisabled" :class="['flex shadow rounded-xl', { 'cursor-not-allowed': isAddToBagDisabled }]">
					<button
						@click="quantity > 1 ? quantity-- : null"
						class="bg-gradient-to-b from-ihh-pink to-ihh-purple text-ihh-midnight-gray h-full px-4 sm:px-6 py-3 text-xl rounded-l-xl"
					>
						-
					</button>
					<input
						type="number"
						class="shrink-0 !w-10 sm:!w-16 flex w-full justify-center items-center text-center text-xl text-black px-1 focus:outline-none focus:ring-1 focus:ring-ihh-dark-salmon rounded z-10"
						v-model="quantity"
						@input="validateQuantity"
					/>
					<button @click="increaseQty()" class="bg-gradient-to-b from-ihh-pink to-ihh-purple text-ihh-midnight-gray h-full px-4 sm:px-6 py-3 text-xl rounded-r-xl">
						+
					</button>
				</div>
			</div>

			<button
				v-if="!existingItem"
				@click="$emit('addToBag', textValues)"
				:class="addToBagButtonClass"
				:disabled="isAddToBagDisabled"
				:style="qty === cartQty && qty > 0 ? 'pointer-events: none;' : ''"
				v-html="buttonText"
			></button>
			<div v-else @click="$emit('addToBag', textValues)" class="text-black">In&nbsp;{{ store.editingKit ? 'Kit' : 'Cart' }}</div>
		</div>

		<div class="my-4" v-if="variant?.bcId">
			<ClydeCTA :product="product" :variant="variant" @contractSelected="handleContractSelected" @contractRemoved="handleContractRemoved" :active="active" />
		</div>

		<!-- Use sendlane OutOfStock notification instead -->
		<!-- <div v-if="product.outOfStock" class="flex w-full justify-start bg-ihh-check p-4 rounded mt-4 print:hidden">
            <div class="flex mr-4">
                <img src="/images/ob-alert.svg" alt="option Icons" class="w-8 h-8 p-1 mr-4 m-auto" />
            </div>
            <div class="w-full justify-start text-black text-start m-auto">The selected product is currently unavailable.</div>
        </div> -->

		<!-- Fast Shipping, Satisfaction Guarantee, Easy Returns -->
		<div class="flex w-full justify-between space-x-8 mt-6">
			<div class="flex w-fits justify-around" v-for="p in perks" :key="p">
				<div class="flex items-center">
					<img :src="p.image" alt="Features Icons" class="w-8 h-8 bg-ihh-white shadow-md rounded-lg p-1 m-auto mr-2" />
					<div class="text-start text-ihh-midnight-gray text-sm font-semibold">
						{{ p.title }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ProductOptionButtons from '../partials/product-option-buttons.vue'
import ClydeCTA from '../products/clyde-cta.vue'
import ProductModifiers from '../pages/ihh-items/product-modifiers.vue'
import Swal from 'sweetalert2'
export default {
	props: ['product', 'variant', 'qty', 'cartQty', 'selectedOptions', 'isAddToBagDisabled', 'active', 'stockAvailable', 'currentStock'],
	inject: ['store'],
	components: { ProductOptionButtons, ClydeCTA, ProductModifiers },
	data() {
		return {
			quantity: this.qty,
			perks: [
				{
					// title: "Fast Shipping",
					title: 'Fast Shipping',
					image: '/images/ob-shipping.svg',
				},
				{
					title: 'Satisfaction Guarantee',
					// title: "Fast Shipping",
					image: '/images/ob-smiley0129.svg',
				},
				{
					title: 'Easy Returns',
					// title: "Fast Shipping",
					image: '/images/ob-returns.svg',
				},
			],
			textValues: [],
		}
	},
	methods: {
		scrollToDetails() {
			document.getElementById('details').scrollIntoView({ behavior: 'smooth' })
		},
		selectOption(option) {
			this.$emit('selectOption', option)
		},
		handleContractSelected(contract) {
			console.log('ADCT: Handling Contract selected')
			this.$emit('contractSelected', contract)
		},
		handleContractRemoved() {
			console.log('ATCT: Handling Contract removed')
			this.$emit('contractRemoved')
		},
		selectModifierOption(modifierId, item) {
			this.$emit('modifierOptionSelected', modifierId, item)
		},
		removeModifierOption(modifierId) {
			this.$emit('modifierOptionRemoved', modifierId)
		},
		increaseQty() {
			if (this.quantity < this.currentStock) {
				this.quantity++
			} else {
				// Ensure the quantity is set to the current stock
				this.quantity = this.currentStock

				Swal.fire({
					icon: 'warning',
					title: 'Low Stock',
					text: `Only ${this.currentStock} left in stock!`,
					confirmButtonColor: '#e59789',
				})
			}
		},
		validateQuantity() {
			// Convert to number to ensure proper comparison
			const numQuantity = Number(this.quantity)
			if (numQuantity > this.currentStock) {
				// Use $nextTick to ensure the DOM has been updated
				this.$nextTick(() => {
					this.quantity = this.currentStock
					Swal.fire({
						icon: 'warning',
						title: 'Low Stock',
						text: `Only ${this.currentStock} left in stock!`,
						confirmButtonColor: '#e59789',
					})
				})
			}
		},
	},
	watch: {
		quantity(newQuantity) {
			this.$emit('update:qty', newQuantity)
		},
		qty(newQty) {
			this.quantity = newQty
		},
		productTextModifiers: {
			immediate: true,
			handler(newModifiers) {
				this.textValues = (newModifiers || []).map((mod) => ({
					name: mod.displayName,
					value: '',
					id: mod.id,
					required: mod.required,
				}))
			},
		},
	},
	computed: {
		buttonText() {
			if (this.isAddToBagDisabled) {
				return 'Out of Stock'
			}

			if (this.cartQty === null) {
				return `Add to ${this.store.editingKit ? 'Kit' : 'Bag'}`
			}

			if (this.qty !== this.cartQty) {
				return `Update ${this.store.editingKit ? 'Kit' : 'Bag'}`
			} else if (this.qty === this.cartQty && this.cartQty > 0) {
				return `${this.qty > 1 ? 'Items' : 'Item'} In ${this.store.editingKit ? 'Kit' : 'Bag'}`
			}

			return `Add to ${this.store.editingKit ? 'Kit' : 'Bag'}`
		},
		addToBagButtonClass() {
			return [
				'text-base md2:text-lg font-medium text-ihh-midnight-gray py-3 px-6 md:px-8 lg:px-10 xl:px-16 w-full rounded-lg delay-100 transition tracking-wide whitespace-nowrap',
				{
					'bg-ihh-midnight-gray text-ihh-white opacity-40 disabled:cursor-not-allowed': this.isAddToBagDisabled,
					'bg-ihh-dark-salmon hover:bg-ihh-salmon': !this.isAddToBagDisabled,
				},
			]
		},
		variantsOutOfStock() {
			return this.product?.variants?.every((v) => v.inventoryLevel <= 0) && this.product.inventoryTracking === 'variant'
		},
		productAndVariantsOutOfStock() {
			return this.product?.outOfStock || this.variantsOutOfStock
		},
		nonTextModifiers() {
			return this.product?.modifiers?.filter((m) => m.type !== 'text')
		},
		productTextModifiers() {
			if (!this.product?.modifiers?.length) {
				return []
			}

			const textModifiers = this.product.modifiers.filter((modifier) => modifier.type === 'text')
			return textModifiers
		},
	},
}
</script>

<style></style>
